module.exports = __webpack_public_path__ + "static/img/source-m@2x.830cff29.png";